<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Chart.js</h1>
					<p waBody="m" waText>Lightweight charting with Chart.js &mdash; bar, line, pie, doughnut, radar, and polar area charts configured entirely in Java with JSON output. Based on the Chart.java library for seamless integration between Java backend and Chart.js frontend.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Chart.js</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:chartjs</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.chartjs</p>
					<p waBody="s" waText>Built on: Chart.js 2.x</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_75" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_76" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>COMPONENTS</div>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>BarChart</h4>
								<p waBody="s" waColorText="quiet" waText>Chart.js bar chart with typed dataset API</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins.chartjs</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>LineChart</h4>
								<p waBody="s" waColorText="quiet" waText>Chart.js line chart with point styles and fill</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins.chartjs</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>PieChart</h4>
								<p waBody="s" waColorText="quiet" waText>Chart.js pie chart with segment customization</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins.chartjs</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>DoughnutChart</h4>
								<p waBody="s" waColorText="quiet" waText>Chart.js doughnut chart</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins.chartjs</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>RadarChart</h4>
								<p waBody="s" waColorText="quiet" waText>Chart.js radar chart for multi-axis comparison</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.plugins.chartjs</div>
							</div>
						</wa-card>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>Bar charts with configurable datasets, colors, and border widths</p>
					<p waBody="s" waColorText="quiet" waText>Line charts with point styles, tension, and fill options</p>
					<p waBody="s" waColorText="quiet" waText>Pie and doughnut charts with segment customization</p>
					<p waBody="s" waColorText="quiet" waText>Radar charts for multi-axis data comparison</p>
					<p waBody="s" waColorText="quiet" waText>Polar area charts with angular scales</p>
					<p waBody="s" waColorText="quiet" waText>Color API for type-safe color definitions</p>
					<p waBody="s" waColorText="quiet" waText>Java to JSON serialization &mdash; toJson&#40;&#41; for direct Chart.js consumption</p>
					<p waBody="s" waColorText="quiet" waText>Lightweight &mdash; minimal dependencies compared to enterprise charting</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Bar Chart</h4>
						<p waBody="s" waColorText="quiet" waText>Create a bar chart with colored datasets.</p>
						<markdown [data]="mdContent_77" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_78" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://www.chartjs.org/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://www.chartjs.org/docs/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/ChartJS</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>